export default __webpack_public_path__ + "images/f7e3f3c07e651c7ec92e5ba150cf64fd-Erfolgsfaktor-Kundendienst.jpg";